import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Check, X, Loader2, ArrowRight } from 'lucide-react';
import axios from 'axios';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const EmailVerification = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Kein Verifizierungstoken gefunden');
        return;
      }

      try {
        const response = await axios.post(`${BACKEND_URL}/api/membership/verify-email`, {
          token: token
        });

        if (response.data.success) {
          setStatus('success');
          setMessage(`E-Mail-Adresse ${response.data.email} wurde erfolgreich verifiziert!`);
        }
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.detail || 'Verifizierung fehlgeschlagen');
      }
    };

    verifyEmail();
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className={`w-20 h-20 mx-auto mb-4 rounded-full flex items-center justify-center ${
            status === 'verifying' ? 'bg-blue-100' :
            status === 'success' ? 'bg-green-100' : 'bg-red-100'
          }`}>
            {status === 'verifying' && (
              <Loader2 className="h-10 w-10 text-blue-600 animate-spin" />
            )}
            {status === 'success' && (
              <Check className="h-10 w-10 text-green-600" />
            )}
            {status === 'error' && (
              <X className="h-10 w-10 text-red-600" />
            )}
          </div>
          <CardTitle className={
            status === 'verifying' ? 'text-blue-600' :
            status === 'success' ? 'text-green-600' : 'text-red-600'
          }>
            {status === 'verifying' && 'E-Mail wird verifiziert...'}
            {status === 'success' && 'Verifizierung erfolgreich!'}
            {status === 'error' && 'Verifizierung fehlgeschlagen'}
          </CardTitle>
          <CardDescription>
            {message}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {status === 'success' && (
            <>
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <p className="text-green-700 text-sm">
                  <strong>Nächster Schritt:</strong><br />
                  Sie können das Registrierungsformular jetzt fortsetzen. 
                  Klicken Sie dort auf "Ich habe die E-Mail bestätigt".
                </p>
              </div>
              <Button 
                onClick={() => navigate('/#flatrate')}
                className="w-full bg-gradient-to-r from-blue-600 to-orange-500 hover:from-blue-700 hover:to-orange-600"
              >
                Zur Registrierung <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
            </>
          )}
          
          {status === 'error' && (
            <>
              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <p className="text-red-700 text-sm">
                  Der Verifizierungslink ist möglicherweise abgelaufen oder ungültig.
                  Bitte fordern Sie einen neuen Link an.
                </p>
              </div>
              <Button 
                onClick={() => navigate('/#flatrate')}
                variant="outline"
                className="w-full"
              >
                Zurück zur Startseite
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default EmailVerification;
